import { IonContent, IonPage, useIonAlert, useIonToast, useIonViewWillEnter } from '@ionic/react'
import { warning } from 'ionicons/icons'
import { observer } from 'mobx-react'
import { useContext } from 'react'
import { RouteComponentProps } from 'react-router'
import styled from 'styled-components'
import { CustomSpacer, StyleIonHeader } from '../../../components'
import { DivideLine, DivideLineBold } from '../../../components/atoms/divide'
import { TextStyle } from '../../../components/atoms/text'
import { StoresContext } from '../../../provider/StoreProvider'
import { SubTitle } from '../components'

export const Setting: React.FC<RouteComponentProps> = observer(({ history }) => {
  const { commonStore, authStore } = useContext(StoresContext)
  const [presentAlert] = useIonAlert()
  const [presentToast] = useIonToast()

  useIonViewWillEnter(() => {
    commonStore.setShowTab(false)
  })

  const onSignOut = () => {
    presentAlert({
      mode: 'md',
      header: '정말 로그아웃하시겠습니까?',
      cssClass: 'custom-alert-alert ',
      buttons: [
        {
          text: '아니요',
          cssClass: 'alert-button-cancel',
        },
        {
          text: '네',
          cssClass: 'alert-button-confirm',
          handler: async () => {
            const result = await authStore.signOut()
            if (result === 200) {
              history.push('/home')
              setTimeout(() => {
                location.reload()
              }, 300)
            } else {
              presentToast({
                message: '로그아웃에 실패했습니다!',
                duration: 3000,
                position: 'top',
                color: 'danger',
                icon: warning,
              })
            }
          },
        },
      ],
    })
  }

  return (
    <IonPage>
      <StyleIonHeader type={'SUB'} title={'설정'} href={'/myPage'} />
      <IonContent>
        <TextWrap>
          <TextStyle type={'r_13'} color={'primary_light'}>
            일반
          </TextStyle>
        </TextWrap>
        <SubTitle title={'개인 정보'} href={'/myPage/setting/profile'} />
        <DivideLine isShort={true} />
        <SubTitle title={'닉네임'} subTitle={authStore.userInfo?.nickname ?? '-'} href={'/myPage/setting/nickname'} />
        <DivideLine isShort={true} />
        <SubTitle title={'자택 주소 변경'} href={'/myPage/setting/address'} />
        <CustomSpacer spacing="24px" />
        <DivideLineBold />
        <TextWrap>
          <TextStyle type={'r_13'} color={'primary_light'}>
            내 정보 관리
          </TextStyle>
        </TextWrap>
        <SubTitle title={'지갑 주소'} href={'/myPage/setting/wallet'} />
        <DivideLine isShort={true} />
        <SubTitle title={'예치금 출금 계좌'} href={'/myPage/setting/account'} />
        <DivideLine isShort={true} />
        <SubTitle title={'현금영수증'} href={'/myPage/setting/cashReceipt'} />
        <CustomSpacer spacing="24px" />
        <DivideLineBold />
        <TextWrap>
          <TextStyle type={'r_13'} color={'primary_light'}>
            계정 관리
          </TextStyle>
        </TextWrap>
        <SubTitle title={'로그아웃'} onClick={onSignOut} />
        <CustomSpacer spacing="24px" />
      </IonContent>
    </IonPage>
  )
})

const TextWrap = styled.div`
  margin: 24px 20px 8px;
`
